class MobileSearchBar extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener(
      'click',
      () =>
        (document.getElementById(this.getAttribute('aria-controls')).open =
          true)
    );
  }
}

if (!customElements.get('mobile-search-bar')) {
  customElements.define('mobile-search-bar', MobileSearchBar, { extends: 'button' });
}
